export  const gameDictionary = {
help:{fa:"راهنما" , en:"Help"},
gameStory:{fa:"داستان بازی" , en:"Baziigram story"},
baziigramStoryTxt:{fa:"اینجا سرزمین بازیگرام است." + "<br/>" +
 "در ایران قبیله ای از بازی های دیجیتال وجود داشتند که علی رغم اینکه مردم آنها را دوست داشتند اما این قبیله هیچ جایی برای زندگی نداشت و همیشه سرگردان بود." +
"<br/>" +
"تا اینکه ققنوس آنها را پیدا کرد و در این سرزمین آنها را اسکان داد." +
"<br/>" +
"بازی ها خوشحال بودند که سرزمینی مختص خودشان دارند و با شادی زندگی میکردند تا اینکه اهریمن پوچستان به اینجا حمله کرد و روز را از این سرزمین دزدید." +
"<br/>"
+
"برای جنگ با اهریمن باید سنگ زندگی را پیدا کنید."
+
"<br/>" +
"با ققنوس همراه شوید تا دوباره صبح را به این سرزمین برگردانیم."
, en:"Here is the land of Bazigram." + "<br/>" +
      "There was a tribe of digital games that, despite the fact that people loved them, this tribe had nowhere to live and was always wandering." +
     "<br/>" +
     "Finally, the Phoenix found them and settled them in this land." +
     "<br/>" +
     "The games were happy to have their own land and lived happily until the demon Puchestan attacked here and stole the light from this land." +
     "<br/>"
     +
     "To fight the demon you need to find the stone of life."
     +
     "<br/>" +
     "Join the Phoenix to bring the light back to this land."},


}